import { SseEventSource } from './services/http/sse-event-source';
import { typeBlock, typeFace } from '@monorepo/models';
import buildInfo from './build-timestamp.json';

export const isLocalhost = Boolean(
    window.location.hostname === 'localhost' ||
    window.location.hostname === '[::1]' ||
    window.location.hostname.match(/^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/)
);

export const currentOrigin = 'https://asistentecongre.com';

export const appName = document.title;

export const SERVER = isLocalhost ? 'http://localhost:4005' : 'https://asistente-congre-service-681492137276.southamerica-east1.run.app';

export const pointer = {
    aiAgent: `${SERVER}/api/ai-agent`,
    board: `${SERVER}/api/board`,
    campaign: `${SERVER}/api/campaign`,
    cart: `${SERVER}/api/cart`,
    config: `${SERVER}/api/config`,
    email: `${SERVER}/api/email`,
    geocoding: `${SERVER}/api/geocoding`,
    houseToHouse: `${SERVER}/api/house-to-house`,
    log: `${SERVER}/api/log`,
    map: `${SERVER}/api/map`,
    meeting: `${SERVER}/api/meeting`,
    notification: `${SERVER}/api/notification`,
    publicMinistry: `${SERVER}/api/public-ministry`,
    sse: `${SERVER}/api/sse`,
    telephonic: `${SERVER}/api/telephonic`,
    transcription: `${SERVER}/api/transcription`,
    user: `${SERVER}/api/user`,
    weather: `${SERVER}/api/weather`
};

export const sse = new SseEventSource(pointer.sse);

export const reconnectSse = (): void => {
    sse.reconnect();
};

export const recaptchaPublicKey = '6Lfa-RstAAAAANzxObVHreXyZjnKx2IxbpncNT1U';

export const firebaseConfig = {
    apiKey: "AIzaSyB0_WVuA3UEAdu_mz6cdfKL21rSUOgVl6s",
    authDomain: "asistentecongre.firebaseapp.com",
    projectId: "asistentecongre",
    storageBucket: "asistentecongre.firebasestorage.app",
    messagingSenderId: "681492137276",
    appId: "1:681492137276:web:5442389af1057b467a4a39",
    measurementId: "G-NQ987M6WPS"
};

export const lastDeployTimestamp = buildInfo.buildTimestamp || Date.now();

export const hthConfigOptions = {
    blocks: ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12', '13', '14', '15'] as typeBlock[],
    faces: ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J'] as typeFace[],
    buildingDoorNumbers: Array.from({ length: 30 }, (_, i) => i + 1),  // 1-30
    buildingLevels: Array.from({ length: 51 }, (_, i) => i)  // PB-50
};

export const googleMapConfig = {
    googleMapsApiKey: isLocalhost ? 'AIzaSyD7mgdNrEU8B4CrqXaIm3knuvsZ5l1zweI' : 'AIzaSyAtHMVO6smRYUMxmecTrMmvV8Jd9AmOGAQ',
    id: 'ad09b84d2db0b86d',
    language: 'es',
    libraries: ['maps', 'places'] as any,
    region: 'AR'
};

export const placesBounds = {
    east: -58.353243,
    north: -34.562694,
    south: -34.705957,
    west: -58.530468
};

export const initCoordinates = { lat: -34.6258549, lng: -58.4343211 };

export const breakingPoint = 992;    // < mobile
export const generalBlue = '#4a6da7';
export const generalBlueDark = '#25457d';
export const generalRed = '#b02a37';
